// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { logger } from '../utils/secureLogger';

// Firebase configuration - パブリックキーなので公開されても問題ないが、ドメイン制限を推奨
const firebaseConfig = {
  apiKey: "AIzaSyB7zBtM3RgHnhBvNB6zg1vrMw5FmuAbBik", // パブリックキー（ドメイン制限済み）
  authDomain: "pixelart.tokyo", // カスタム認証ドメイン
  projectId: "photo-2-card-game-maker",
  storageBucket: "photo-2-card-game-maker.firebasestorage.app",
  messagingSenderId: "1003664674077",
  appId: "1:1003664674077:web:d618ec87bf3d78242d25f4",
  measurementId: "G-6FVHV4RRWK"
};

// Initialize Firebase
let app;
let db;
let auth;
let googleProvider;

try {
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
  
  // Google認証プロバイダーの設定
  googleProvider.addScope('profile');
  googleProvider.addScope('email');
  googleProvider.setCustomParameters({
    prompt: 'select_account'
  });
  
  logger.info("Firebase initialized successfully");
  logger.silent("Project ID:", firebaseConfig.projectId);
  
  // Only connect to emulator in development if needed
  // if (process.env.NODE_ENV === 'development' && !db._delegate._databaseId.projectId.includes('demo-')) {
  //   connectFirestoreEmulator(db, 'localhost', 8080);
  // }
  
} catch (error) {
  logger.error("Error initializing Firebase:", error);
  throw new Error("Failed to initialize Firebase. Please check your configuration.");
}

// Test Firestore connection
const testFirestoreConnection = async () => {
  try {
    // Try to read from a test collection
    const { collection, getDocs } = await import("firebase/firestore");
    await getDocs(collection(db, "test"));
    logger.info("Firestore connection test successful");
  } catch (error) {
    logger.warn("Firestore connection test failed:", error);
  }
};

// Run connection test
testFirestoreConnection();

// Initialize Cloud Firestore and get a reference to the service
export { db, auth, googleProvider };
